/**
 * Analytics Configuration for Capitol View Stays
 * 
 * GA4 Measurement ID: G-XQJHXQYX65 (configured in index.html)
 */

export const analyticsConfig = {
  // Google Analytics 4 - ENABLED
  googleAnalytics: {
    enabled: true,
    measurementId: 'G-XQJHXQYX65',
  },
  
  // Meta Pixel (Facebook/Instagram) - Not configured
  metaPixel: {
    enabled: false,
    pixelId: '',
  },
  
  // Google Tag Manager - Not needed (using GA4 directly)
  googleTagManager: {
    enabled: false,
    containerId: '',
  },
};

/**
 * Initialize analytics scripts
 * Call this in your App.js or index.js
 */
export const initializeAnalytics = () => {
  // Google Analytics 4
  if (analyticsConfig.googleAnalytics.enabled) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsConfig.googleAnalytics.measurementId}`;
    document.head.appendChild(script1);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', analyticsConfig.googleAnalytics.measurementId);
    window.gtag = gtag;
  }

  // Meta Pixel
  if (analyticsConfig.metaPixel.enabled) {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', analyticsConfig.metaPixel.pixelId);
    window.fbq('track', 'PageView');
  }

  // Google Tag Manager
  if (analyticsConfig.googleTagManager.enabled) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', analyticsConfig.googleTagManager.containerId);
  }
};

/**
 * Track custom events - uses gtag directly since GA4 is loaded in index.html
 */
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics 4
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
  
  // Meta Pixel (if enabled)
  if (analyticsConfig.metaPixel.enabled && window.fbq) {
    window.fbq('track', eventName, eventParams);
  }
};

/**
 * Common events for vacation rentals
 */
export const trackPropertyView = (propertyName, propertyId) => {
  trackEvent('view_item', {
    item_name: propertyName,
    item_id: propertyId,
    content_type: 'property'
  });
};

export const trackBookingStart = (propertyName, propertyId) => {
  trackEvent('begin_checkout', {
    item_name: propertyName,
    item_id: propertyId,
  });
};

export const trackContactForm = () => {
  trackEvent('generate_lead', {
    content_name: 'Contact Form'
  });
};

export const trackEmailSignup = () => {
  trackEvent('sign_up', {
    method: 'email_popup'
  });
};

/**
 * Track booking confirmation - critical for conversion tracking
 * This is designed to work with GTM + GA4 data layer approach
 * 
 * @param {Object} data - Booking data
 * @param {string} data.bookingId - Unique booking reference ID
 * @param {number} [data.value] - Booking value/total
 * @param {string} [data.currency] - Currency code (default: USD)
 * @param {string} [data.propertyName] - Name of the booked property
 * @param {string} [data.source] - Booking source (e.g., 'direct', 'uplisting')
 */
export const trackBookingConfirmed = (data) => {
  // Push to data layer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'booking_confirmed',
    booking_id: data.bookingId,
    value: data.value,
    currency: data.currency || 'USD',
    property_name: data.propertyName,
    booking_source: data.source || 'direct'
  });
  
  // Send to GA4 via gtag
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: data.bookingId,
      value: data.value,
      currency: data.currency || 'USD',
      items: [{
        item_name: data.propertyName,
        item_category: 'vacation_rental'
      }]
    });
  }
  
  // Meta Pixel conversion (if enabled)
  if (analyticsConfig.metaPixel.enabled && window.fbq) {
    window.fbq('track', 'Purchase', {
      value: data.value,
      currency: data.currency || 'USD',
      content_name: data.propertyName,
      content_type: 'vacation_rental'
    });
  }
  
  console.log('[Analytics] Booking confirmed:', data.bookingId);
};
